// Device - connections
export const CONNECT = 'CONNECT'
// {type:CONNECT}
export const DISCONNECT = 'DISCONNECT'
// {type:DISCONNECT}
export const RECONNECT = 'RECONNECT'
// {type:RECONNECT}

// Device - get device firmware
export const REQUEST_FIRMWARE_VERSION = 'REQUEST_FIRMWARE_VERSION' // request fw/bl from device
// {type:REQUEST_FIRMWARE_VERSION, error: false}
export const SET_FIRMWARE_VERSION = 'SET_FIRMWARE_VERSION'
// {type:REQUEST_FIRMWARE_VERSION, versions: {firmware: "0.0.0", bootloader: "0.0.0"}}
export const FETCH_FIRMWARE_VERSION = 'FETCH_FIRMWARE_VERSION'
// {type:FETCH_FIRMWARE_VERSION}
export const SET_AVAILABLE_FIRMWARE = 'SET_AVAILABLE_FIRMWARE'
// {type:SET_AVAILABLE_FIRMWARE, version: version}

// Device - Firmware Updating
export const DEVICE_UPDATE_FIRMWARE = 'DEVICE_UPDATE_FIRMWARE'
// {type:DEVICE_UPDATE_FIRMWARE, error: true}
export const UPDATE_FIRMWARE = 'UPDATE_FIRMWARE'
// {type:UPDATE_FIRMWARE, error: false}
export const FETCH_FIRMWARE = 'FETCH_FIRMWARE'
// {type:FETCH_FIRMWARE}
export const SET_FIRMWARE_UPDATE_AVAILABLE = 'SET_FIRMWARE_UPDATE_AVAILABLE'
// {type:SET_FIRMWARE_UPDATE_AVAILABLE, updateable: firmwareUpdateAvailable}
export const SET_PREVIOUS_FIRMWARE_VERSION = 'SET_PREVIOUS_FIRMWARE_VERSION'
// {type:SET_PREVIOUS_FIRMWARE_VERSION, version: '1.0.4'}
export const DEVICE_ENTER_BOOTLOADER = 'DEVICE_ENTER_BOOTLOADER'
// {type:DEVICE_ENTER_BOOTLOADER}
export const BOOTLOADER_READY = 'BOOTLOADER_READY'
// {type:BOOTLOADER_READY}
export const SET_BOOTLOADER_MODE = 'SET_BOOTLOADER_MODE'
// {type:SET_BOOTLOADER_MODE, active: true}
export const BOOTLOADER_DISCONNECT = 'BOOTLOADER_DISCONNECT'
// {type:BOOTLOADER_DISCONNECT}
export const SEND_FIRMWARE = 'SEND_FIRMWARE'
// {type:SEND_FIRMWARE}
export const FIRMWARE_UPDATE_COMPLETE = 'FIRMWARE_UPDATE_COMPLETE'
// {type:FIRMWARE_UPDATE_COMPLETE}

// Device - Global
export const SET_BUTTON_PRESET_MODE = 'SET_BUTTON_PRESET_MODE'
// {type:SET_BUTTON_PRESET_MODE, id: 0, mode: 1}
export const DEVICE_REQUEST_FIRMWARE_VERSIONS = 'DEVICE_REQUEST_FIRMWARE_VERSIONS'
//{type:DEVICE_REQUEST_FIRMWARE_VERSIONS}:  malletStation.getFirmwareVersion()
export const DEVICE_REQUEST_PRESET = 'DEVICE_REQUEST_PRESET'
//{type:DEVICE_REQUEST_PRESET}:  malletStation.getPreset()
export const DEVICE_REQUEST_BUTTON_MODE = 'DEVICE_REQUEST_BUTTON_MODE'
//{type:DEVICE_REQUEST_BUTTON_MODE}:  malletStation.getButtonMode()
export const DEVICE_REQUEST_USER_CURVE = 'DEVICE_REQUEST_USER_CURVE'
//{type:DEVICE_REQUEST_USER_CURVE}:  malletStation.getUserCurve()
export const DEVICE_LOAD_PRESET_TO_BUFFER = 'DEVICE_LOAD_PRESET_TO_BUFFER'
//{type:DEVICE_LOAD_PRESET_TO_BUFFER}:  malletStation.loadPreset()
export const DEVICE_SAVE_PRESET_TO_MEMORY = 'DEVICE_SAVE_PRESET_TO_MEMORY'
//{type:DEVICE_SAVE_PRESET_TO_MEMORY}:  malletStation.savePreset()
export const REQUEST_VELOCITY_CURVES = 'REQUEST_VELOCITY_CURVES'
// {type:REQUEST_VELOCITY_CURVES, error: false}
export const DEVICE_SAVE_USER_CURVE = 'DEVICE_SAVE_USER_CURVE'
//{type:DEVICE_SAVE_USER_CURVE}:  malletStation.saveUserCurve()
export const DEVICE_SET_BUTTON_MODE = 'DEVICE_SET_BUTTON_MODE'
//{type:DEVICE_SET_BUTTON_MODE}:  malletStation.setButtonMode()
export const DEVICE_SET_BUTTON_MODES = 'DEVICE_SET_BUTTON_MODES'
//{type:DEVICE_SET_BUTTON_MODES}:  malletStation.setButtonMode()
export const DEVICE_SET_BAR_AVERAGE = 'DEVICE_SET_BAR_AVERAGE'
//{type:DEVICE_SET_BAR_AVERAGE, mode: 'low', barIndex: 0, average: 23.2}:  malletStation.setBarAverage('low', 0, 22.3)
export const DEVICE_SET_BAR_MULT = 'DEVICE_SET_BAR_MULT'
//{type:DEVICE_SET_BAR_MULT}: mode: 'low' malletStation.setBarMult(0,'1.00')
export const DEVICE_REQUEST_CROSSTALK_VELOCITY = 'DEVICE_REQUEST_CROSSTALK_VELOCITY'
//{type:DEVICE_REQUEST_CROSSTALK_VELOCITY}:  malletStation.crosstalkVelocity(value)
export const DEVICE_SET_CROSSTALK_THRESHOLD = 'DEVICE_SET_CROSSTALK_THRESHOLD'
//{type:DEVICE_SET_CROSSTALK_THRESHOLD}:  malletStation.crosstalkVelocity(value)
export const DEVICE_REQUEST_GLOBAL_THRESHOLD = 'DEVICE_REQUEST_GLOBAL_THRESHOLD'
//{type:DEVICE_REQUEST_GLOBAL_THRESHOLD}
export const DEVICE_SET_GLOBAL_THRESHOLD = 'DEVICE_SET_GLOBAL_THRESHOLD'
//{type:DEVICE_SET_GLOBAL_THRESHOLD, threshold: 1.00}
export const DEVICE_RESET = 'DEVICE_RESET'
//{type:DEVICE_RESET}:  malletStation.reset()

// Editor
export const SET_AVAILABLE_EDITOR = 'SET_AVAILABLE_EDITOR'
// {type:SET_AVAILABLE_EDITOR, version: version}
export const SET_EDITOR_UPDATE_AVAILABLE = "SET_EDITOR_UPDATE_AVAILABLE";
// {type:SET_EDITOR_UPDATE_AVAILABLE, updateable: updateable}
export const SET_UPDATES_AVAILABLE = "SET_UPDATES_AVAILABLE";
// {type:SET_UPDATES_AVAILABLE}
export const NETWORK_CONNECTION = 'NETWORK_CONNECTION'
// {type:NETWORK_CONNECTION, state: true}
export const ONLINE = 'ONLINE'
// {type:ONLINE}
export const OFFLINE = 'OFFLINE'
// {type:OFFLINE}
export const SET_STATUS_MESSAGE = 'SET_STATUS_MESSAGE'
// {type:SET_STATUS_MESSAGE, message: ''}
export const TOGGLE_PRESET_DIALOG = 'TOGGLE_PRESET_DIALOG'
// {type:TOGGLE_PRESET_DIALOG}
export const SELECT_BAR = 'SELECT_BAR' // select bar for gain setting
// {type:SELECT_BAR, bar: 1}
export const SELECT_GAP_CAP = 'SELECT_GAP_CAP' // select gap cap for note assignment
// {type:SELECT_GAP_CAP, bar: 1}
export const BAR_INFO_ACTIVE = 'BAR_INFO_ACTIVE'
// {type:BAR_INFO_ACTIVE, active: true}
export const SET_BAR_INFO = 'SET_BAR_INFO'
// {type:SET_BAR_INFO, bar: 1, info: 'BAR: 11 MIDI: 25 Note: C#2 Gain: 1'}
export const SELECT_ZONE = 'SELECT_ZONE'
// {type:SELECT_ZONE, zone: 0}
export const SELECT_BUTTON = 'SELECT_BUTTON'
// {type:SELECT_BUTTON, index: 1}
export const SELECT_FADER = 'SELECT_FADER'
// {type:SELECT_FADER, index: 1}
export const SELECT_PEDAL = 'SELECT_PEDAL'
// {type:SELECT_PEDAL, index: 1}
export const OPEN_VELOCITY_CURVES = 'OPEN_VELOCITY_CURVES'
// {type:OPEN_VELOCITY_CURVES}
export const CLOSE_VELOCITY_CURVES = 'CLOSE_VELOCITY_CURVES'
// {type:CLOSE_VELOCITY_CURVES}
export const REVERTABLE_PRESET = 'REVERTABLE_PRESET'
// {type:REVERTABLE_PRESET, diffLength: length}
export const RESET_DEVICE_PRESETS_IN_STATE = 'RESET_DEVICE_PRESETS_IN_STATE'
// {type:RESET_DEVICE_PRESETS_IN_STATE}
export const DEVICE_PRESETS_LOADED = 'DEVICE_PRESETS_LOADED'
// {type:DEVICE_PRESETS_LOADED, status: true}
export const INITIAL_PRESET_LOADED = 'INITIAL_PRESET_LOADED'
// {type:INITIAL_PRESET_LOADED}
export const OPEN_PRESET_RENAMER = 'OPEN_PRESET_RENAMER'
// {type:OPEN_PRESET_RENAMER}
export const CLOSE_PRESET_RENAMER = 'CLOSE_PRESET_RENAMER'
// {type:CLOSE_PRESET_RENAMER}
export const SET_TEMP_IMPORTED_PRESETS = 'SET_TEMP_IMPORTED_PRESETS'
// {type:SET_TEMP_IMPORTED_PRESETS, presets: presets}
export const SET_IMPORTED_PRESET_NAME = 'SET_IMPORTED_PRESET_NAME'
// {type:SET_IMPORTED_PRESET_NAME, names: name, index: index}
export const SET_IMPORTED_PRESET_NAMES = 'SET_IMPORTED_PRESET_NAMES'
// {type:SET_IMPORTED_PRESET_NAMES, names: []}
export const RESET_IMPORTED_NAMES = 'RESET_IMPORTED_NAMES'
// {type:RESET_IMPORTED_NAMES}
export const SENSITIVITY_PRESET = 'SENSITIVITY_PRESET'
// {type:SENSITIVITY_PRESET}

// Editor Preferences
export const OPEN_PREFERENCES = 'OPEN_PREFERENCES'
// {type:OPEN_PREFERENCES}
export const SET_PREFERENCE_UI_SYNC = 'SET_PREFERENCE_UI_SYNC'
// {type:SET_PREFERENCE_UI_SYNC, active: active}
export const SET_PREFERENCE_TOOLTIPS = 'SET_PREFERENCE_TOOLTIPS'
// {type:SET_PREFERENCE_TOOLTIPS, active: active}
export const SET_PREFERENCE_AUTOHIDE_SPLITS = 'SET_PREFERENCE_AUTOHIDE_SPLITS'
// {type:SET_PREFERENCE_AUTOHIDE_SPLITS, active: active}
export const SET_CROSSTALK_THRESHOLD = 'SET_CROSSTALK_THRESHOLD'
//{type:SET_CROSSTALK_THRESHOLD, value: value}
export const SET_GLOBAL_THRESHOLD = 'SET_GLOBAL_THRESHOLD'
//{type:SET_GLOBAL_THRESHOLD, value: value}
export const SET_SHOW_LEARN_MODE_TOUR = 'SET_SHOW_LEARN_MODE_TOUR'
//{type:SET_SHOW_LEARN_MODE_TOUR, active: active}

// Presets - CRUD
export const DEVICE_SEND_PRESET_TO_BUFFER = 'DEVICE_SEND_PRESET_TO_BUFFER'
//{type:DEVICE_SEND_PRESET_TO_BUFFER}:  malletStation.sendPreset(preset)
export const REQUEST_USER_PRESETS = 'REQUEST_USER_PRESETS'
// {type:REQUEST_USER_PRESETS, presets: []}
export const LOAD_PRESET = 'LOAD_PRESET'
// {type:LOAD_PRESET, preset: {...preset}}
export const SET_CURRENT_PRESET = 'SET_CURRENT_PRESET'
// {type:SET_CURRENT_PRESET, preset: {...preset}}
export const OPEN_UNSAVED_CHANGES = 'OPEN_UNSAVED_CHANGES'
// {type:OPEN_UNSAVED_CHANGES, open: open}
export const BUILD_PRESETS = 'BUILD_PRESETS'
// {type:BUILD_PRESETS, preset: {...preset}}
export const SAVE_PRESET = 'SAVE_PRESET' // user to localStorage
// {type:SAVE_PRESET, name: 'preset name'}
export const SET_USER_PRESET_NAME = 'SET_USER_PRESET_NAME'
// {type:SET_USER_PRESET_NAME, name: 'preset name'}
export const SAVE_NEW_PRESET = 'SAVE_NEW_PRESET'
// {type:SAVE_NEW_PRESET, name: 'preset name'}
export const CANCEL_SAVE_AS_PRESET = 'CANCEL_SAVE_AS_PRESET'
// {type:CANCEL_SAVE_AS_PRESET}
export const DELETE_PRESET = 'DELETE_PRESET'
// {type:DELETE_PRESET}
export const REVERT_PRESET = 'REVERT_PRESET'
// {type:REVERT_PRESET}
export const SEND_PRESET = 'SEND_PRESET' // to device
// {type:SEND_PRESET, destination: 1}
export const SELECT_PRESET_DESTINATION = 'SELECT_PRESET_DESTINATION'
// {type:SELECT_PRESET, destination: 1}
export const SELECT_PRESET = 'SELECT_PRESET'
// {type:SELECT_PRESET, selectedPreset: 'device-0'}
export const ADD_PRESET = 'ADD_PRESET'
// {type:ADD_PRESET, category: 'user', index:0}
export const ADD_PRESETS = 'ADD_PRESETS'
// {type:ADD_PRESETS, category: 'user', index:0}
export const DOWNLOAD_USER_PRESETS = 'DOWNLOAD_USER_PRESETS'
// {type:DOWNLOAD_USER_PRESETS}

// Learn Mode
export const OPEN_LEARN_MODE = 'OPEN_LEARN_MODE'
// {type:OPEN_LEARN_MODE}
export const CLOSE_LEARN_MODE = 'CLOSE_LEARN_MODE'
// {type:CLOSE_LEARN_MODE}
export const ENTER_LEARN_MODE = 'ENTER_LEARN_MODE'
// {type:ENTER_LEARN_MODE}
export const ENTER_NORMAL_MODE = 'ENTER_NORMAL_MODE'
// {type:ENTER_NORMAL_MODE}
export const OPEN_LEARN_MODE_TOUR = 'OPEN_LEARN_MODE_TOUR'
// {type:OPEN_LEARN_MODE_TOUR}

export const DEVICE_REQUEST_ALL_BARS_TARES = 'DEVICE_REQUEST_ALL_BARS_TARES'
// {type:DEVICE_REQUEST_ALL_BARS_TARES}
export const DEVICE_REQUEST_ALL_BARS_AVERAGES = 'DEVICE_REQUEST_ALL_BARS_AVERAGES'
// {type:DEVICE_REQUEST_ALL_BARS_AVERAGES, mode = "low"}
export const DEVICE_REQUEST_ALL_BARS_MULTS = 'DEVICE_REQUEST_ALL_BARS_MULTS'
// {type:DEVICE_REQUEST_ALL_BARS_MULTS, mode = "low"}

export const STORE_BARS_TARE = 'STORE_BARS_TARE'
// {type:STORE_BARS_TARE, bar: 1, tare: '7'}
export const STORE_BARS_AVERAGES = 'STORE_BARS_AVERAGES'
// {type:STORE_BARS_AVERAGES, averageLow: '7'}
export const STORE_BAR_AVERAGE = 'STORE_BAR_AVERAGE'
// {type:STORE_BAR_AVERAGE, mode: 'low', bar: 1, averageHigh: '7'}
export const STORE_BARS_MULTS = 'STORE_BARS_MULTS'
// {type:STORE_BARS_MULTS, mode: 'low', barMults: []}
export const STORE_BAR_MULT = 'STORE_BAR_MULT'
// {type:STORE_BAR_MULT, bar: 1, barMult: '1.00'}


export const SELECT_LEARN_BAR = 'SELECT_LEARN_BAR'
// {type:SELECT_LEARN_BAR}
export const SELECT_ERROR_LEARN_BAR = 'SELECT_ERROR_LEARN_BAR'
// {type:SELECT_ERROR_LEARN_BAR}
export const LEARN_MODE_RECORDING = 'LEARN_MODE_RECORDING'
// {type:LEARN_MODE_RECORDING, recording: true}
export const LEARN_MODE_AUTO_RECORDING = 'LEARN_MODE_AUTO_RECORDING'
// {type:LEARN_MODE_AUTO_RECORDING, learnModeAuto: true}
export const LEARN_MODE_USE_SOUNDS = 'LEARN_MODE_USE_SOUNDS'
// {type:LEARN_MODE_USE_SOUNDS, learnModeUseSounds: true}
export const RECORD_LEARN_BAR = 'RECORD_LEARN_BAR'
// {type:RECORD_LEARN_BAR, current: {"bar": -1, "rawVelocity": -1}}
export const SET_LEARN_STRIKE_COUNT = 'SET_LEARN_STRIKE_COUNT'
// {type:SET_LEARN_STRIKE_COUNT, count: 5}
export const SET_LEARN_STRIKE_TYPE = 'SET_LEARN_STRIKE_TYPE'
// {type:SET_LEARN_STRIKE_TYPE, strikeType: 'soft'}
export const SET_BAR_RECORD = 'SET_BAR_RECORD'
// {type:SET_BAR_RECORD, record: [{record}...]}
export const RESET_BAR_RECORD = 'RESET_BAR_RECORD'
// {type:RESET_BAR_RECORD}
export const RESET_BAR_RECORDS = 'RESET_BAR_RECORDS'
// {type:RESET_BAR_RECORDS}
export const RESET_BAR_STRIKE_ICONS = 'RESET_BAR_STRIKE_ICONS'
// {type:RESET_BAR_STRIKE_ICONS}
export const LEARN_MODE_BAR_STRIKE_STATUS = 'LEARN_MODE_BAR_STRIKE_STATUS'
// {type:LEARN_MODE_BAR_STRIKE_STATUS, barIndex: 0, strikeType: 'soft'}
export const RESET_LEARNED_AVERAGES = 'RESET_LEARNED_AVERAGES'
// {type:RESET_LEARNED_AVERAGES, mode: 'low'}
export const CREATE_BAR_RECORD = 'CREATE_BAR_RECORD'
// {type:CREATE_BAR_RECORD}
export const CALCULATE_BAR_AVERAGE = 'CALCULATE_BAR_AVERAGE'
// {type:CALCULATE_BAR_AVERAGE, mode: 'low', barIndex: 0, average: 1.234}
export const LEARN_MODE_COMPLETE = 'LEARN_MODE_COMPLETE'
// {type:LEARN_MODE_COMPLETE, complete: true}
export const EXPORT_BAR_DATA = 'EXPORT_BAR_DATA'
// {type:EXPORT_BAR_DATA}
export const DEVICE_LEARN_MODE_RESET = 'DEVICE_LEARN_MODE_RESET'
// {type:DEVICE_LEARN_MODE_RESET}

// Presets - param updates
// : Bars & Caps
export const DECREMENT_LOWNOTE = 'DECREMENT_LOWNOTE'
// {type:DECREMENT_LOWNOTE}
export const INCREMENT_LOWNOTE = 'INCREMENT_LOWNOTE'
// {type:INCREMENT_LOWNOTE}
export const DECREMENT_OCTAVE = 'DECREMENT_OCTAVE'
// {type:DECREMENT_OCTAVE}
export const INCREMENT_OCTAVE = 'INCREMENT_OCTAVE'
// {type:INCREMENT_OCTAVE}
export const SET_ZONE_SPLIT_POINT = 'SET_ZONE_SPLIT_POINT'
// {type:SET_SPLIT_POINT, zone: 0, bar: 10}
export const SET_ZONE_CURVE = 'SET_ZONE_CURVE'
// {type:SET_ZONE_A_CURVE, zone: 0, curve: 1}
export const SET_ZONE_CHANNEL = 'SET_ZONE_CHANNEL'
// {type:SET_ZONE_A_CHANNEL, zone: 0, channel: 1}
export const SET_GAP_CAP = 'SET_GAP_CAP'
// {type:SET_GAP_CAP, index: 0, note: 1}
export const SET_GAP_CAPS = 'SET_GAP_CAPS'
// {type:SET_GAP_CAPS, notes: []}
export const SET_GAP_CAPS_CURVE = 'SET_GAP_CAP_CURVE'
// {type:SET_GAP_CAPS_CURVE,  index: 1}
export const SET_GAP_CAPS_CHANNEL = 'SET_GAP_CAPS_CHANNEL'
// {type:SET_GAP_CAPS_CHANNEL, channel: 2}
export const TOGGLE_GAP_CAPS = 'TOGGLE_GAP_CAPS'
// {type:TOGGLE_GAP_CAPS, notes: []}

// : Buttons
export const SET_BUTTON_CHANNEL = 'SET_BUTTON_CHANNEL'
// {type:SET_BUTTON_CHANNEL, index: 1, channel: 1}
export const SET_BUTTON_PROGRAM_CHANGE = 'SET_BUTTON_PROGRAM_CHANGE'
// {type:SET_BUTTON_PROGRAM_CHANGE, index: 1, value: 1}
export const SET_BUTTON_BANK_SELECT = 'SET_BUTTON_BANK_SELECT' // convert to MSB/LSB
// {type:SET_BUTTON_BANK_SELECT, index: 1, value: 1}
export const SET_BUTTON_NOTE = 'SET_BUTTON_NOTE'
// {type:SET_BUTTON_NOTE, index: 1, value: 1}
export const SET_BUTTON_CC = 'SET_BUTTON_CC'
// {type:SET_BUTTON_CC, index: 1, value: 1}

// : Faders
export const SET_FADER_MODE = 'SET_FADER_MODE'
// {type:SET_FADER_MODE, index: 1, mode: 1}
export const SET_FADER_CC = 'SET_FADER_CC'
// {type:SET_FADER_CC, index: 1, CC: 1}
export const SET_FADER_CHANNEL = 'SET_FADER_CHANNEL'
// {type:SET_FADER_CHANNEL, index: 1, channel: 1}

// : Pedals
export const SET_PEDAL_MODE = 'SET_PEDAL_MODE'
// {type:SET_PEDAL_MODE, index: 1, mode: 1}
export const SET_PEDAL_CC = 'SET_PEDAL_CC'
// {type:SET_PEDAL_CC, index: 1, CC: 1}
export const SET_PEDAL_CHANNEL = 'SET_PEDAL_CHANNEL'
// {type:SET_PEDAL_CHANNEL, index: 1, channel: 1}

// : Playability
export const SET_PRESET_GAIN = 'SET_PRESET_GAIN'
// {type:SET_PRESET_GAIN, gain: 1}
export const SELECT_PLAY_MODE = 'SELECT_PLAY_MODE'
// {type:SELECT_PLAY_MODE, mode: 0}
export const SET_MIDI_NOTE_LENGTH = 'SET_MIDI_NOTE_LENGTH'
// {type:SET_MIDI_NOTE_LENGTH, length: 10}
export const SET_DAMP_THRESHOLD = 'SET_DAMP_THRESHOLD'
// {type:SET_DAMP_THRESHOLD, threshold: 10}

// : Velocity Curves
export const SELECT_VELOCITY_CURVE = 'SELECT_VELOCITY_CURVE'
// {type:SELECT_VELOCITY_CURVE, index: 0}
export const SELECT_USER_CURVE = 'SELECT_USER_CURVE'
// {type:SELECT_USER_CURVE, index: 0}
export const SET_USER_CURVE = 'SET_USER_CURVE'
// {type:SET_USER_CURVE, index: 0, curve: []}
export const RESET_USER_CURVE = 'RESET_USER_CURVE'
// {type:RESET_USER_CURVE, index: 0}
